import actionTypes from './actionTypes';

const INIT_STATE = {
  cafeEventsLoading: false,
  cafeEventsFailed: false,
  cafeEventsError: false,
  cafeEventsMessage: null,
  cafeEvents: {},
  cafeEventsList: [],

  archivedCafeEventsLoading: false,
  archivedCafeEventsFailed: false,
  archivedCafeEventsError: false,
  archivedCafeEventsMessage: null,
  archivedCafeEvents: {},
  archivedCafeEventsList: [],

  requestedCafeEventsLoading: false,
  requestedCafeEventsFailed: false,
  requestedCafeEventsError: false,
  requestedCafeEventsMessage: null,
  requestedCafeEvents: {},
  requestedCafeEventsList: [],

  cafeEventDetailsLoading: false,
  cafeEventDetailsFailed: false,
  cafeEventDetailsError: false,
  cafeEventDetailsMessage: null,
  cafeEventDetails: {},

  addCafeEventLoading: false,
  addCafeEventFailed: false,
  addCafeEventError: false,
  addCafeEventMessage: null,

  updateCafeEventLoading: false,
  updateCafeEventFailed: false,
  updateCafeEventError: false,
  updateCafeEventMessage: null,

  confirmEventLoading: false,
  confirmEventFailed: false,
  confirmEventError: false,
  confirmEventMessage: null,

  disableEventLoading: false,
  disableEventFailed: false,
  disableEventError: false,
  disableEventMessage: null,

  rejectEventLoading: false,
  rejectEventFailed: false,
  rejectEventError: false,
  rejectEventMessage: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_CAFE_EVENTS_LOADING: {
      return {
        ...state,
        cafeEventsLoading: true,
        cafeEventsFailed: false,
        cafeEventsError: false,
        cafeEventsMessage: '',
        cafeEvents: {},
        cafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_CAFE_EVENTS_SUCCESS: {
      return {
        ...state,
        cafeEventsLoading: false,
        cafeEventsFailed: false,
        cafeEventsError: false,
        cafeEventsMessage: '',
        cafeEvents: { ...action.payload },
        cafeEventsList: [...action.payload.cafeEvents]
      };
    }
    case actionTypes.FETCH_ALL_CAFE_EVENTS_REJECT: {
      return {
        ...state,
        cafeEventsLoading: false,
        cafeEventsFailed: false,
        cafeEventsError: true,
        cafeEventsMessage: '',
        cafeEvents: {},
        cafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_CAFE_EVENTS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeEventsLoading: false,
        cafeEventsFailed: true,
        cafeEventsError: false,
        cafeEventsMessage: message,
        cafeEvents: {},
        cafeEventsList: []
      };
    }

    case actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_LOADING: {
      return {
        ...state,
        archivedCafeEventsLoading: true,
        archivedCafeEventsFailed: false,
        archivedCafeEventsError: false,
        archivedCafeEventsMessage: null,
        archivedCafeEvents: {},
        archivedCafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_SUCCESS: {
      return {
        ...state,
        archivedCafeEventsLoading: false,
        archivedCafeEventsFailed: false,
        archivedCafeEventsError: false,
        archivedCafeEventsMessage: null,
        archivedCafeEvents: { ...action.payload },
        archivedCafeEventsList: [...action.payload.cafeEvents]
      };
    }
    case actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_REJECT: {
      return {
        ...state,
        archivedCafeEventsLoading: false,
        archivedCafeEventsFailed: false,
        archivedCafeEventsError: true,
        archivedCafeEventsMessage: null,
        archivedCafeEvents: {},
        archivedCafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_ARCHIVED_CAFE_EVENTS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        archivedCafeEventsLoading: false,
        archivedCafeEventsFailed: true,
        archivedCafeEventsError: false,
        archivedCafeEventsMessage: message,
        archivedCafeEvents: {},
        archivedCafeEventsList: []
      };
    }

    case actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_LOADING: {
      return {
        ...state,
        requestedCafeEventsLoading: true,
        requestedCafeEventsFailed: false,
        requestedCafeEventsError: false,
        requestedCafeEventsMessage: null,
        requestedCafeEvents: {},
        requestedCafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_SUCCESS: {
      return {
        ...state,
        requestedCafeEventsLoading: false,
        requestedCafeEventsFailed: false,
        requestedCafeEventsError: false,
        requestedCafeEventsMessage: null,
        requestedCafeEvents: { ...action.payload },
        requestedCafeEventsList: [...action.payload.cafeEvents]
      };
    }
    case actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_REJECT: {
      return {
        ...state,
        requestedCafeEventsLoading: false,
        requestedCafeEventsFailed: false,
        requestedCafeEventsError: true,
        requestedCafeEventsMessage: null,
        requestedCafeEvents: {},
        requestedCafeEventsList: []
      };
    }
    case actionTypes.FETCH_ALL_REQUESTED_CAFE_EVENTS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        requestedCafeEventsLoading: false,
        requestedCafeEventsFailed: true,
        requestedCafeEventsError: false,
        requestedCafeEventsMessage: message,
        requestedCafeEvents: {},
        requestedCafeEventsList: []
      };
    }

    case actionTypes.FETCH_CAFE_EVENT_BY_ID_LOADING: {
      return {
        ...state,
        cafeEventDetailsLoading: true,
        cafeEventDetailsFailed: false,
        cafeEventDetailsError: false,
        cafeEventDetailsMessage: '',
        cafeEventDetails: {}
      };
    }
    case actionTypes.FETCH_CAFE_EVENT_BY_ID_SUCCESS: {
      return {
        ...state,
        cafeEventDetailsLoading: false,
        cafeEventDetailsFailed: false,
        cafeEventDetailsError: false,
        cafeEventDetailsMessage: '',
        cafeEventDetails: { ...action.payload }
      };
    }
    case actionTypes.FETCH_CAFE_EVENT_BY_ID_REJECT: {
      return {
        ...state,
        cafeEventDetailsLoading: false,
        cafeEventDetailsFailed: false,
        cafeEventDetailsError: true,
        cafeEventDetailsMessage: '',
        cafeEventDetails: {}
      };
    }
    case actionTypes.FETCH_CAFE_EVENT_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        cafeEventDetailsLoading: false,
        cafeEventDetailsFailed: true,
        cafeEventDetailsError: false,
        cafeEventDetailsMessage: message,
        cafeEventDetails: {}
      };
    }

    case actionTypes.ADD_CAFE_EVENT_LOADING: {
      return {
        ...state,
        addCafeEventLoading: true,
        addCafeEventFailed: false,
        addCafeEventError: false,
        addCafeEventMessage: null
      };
    }
    case actionTypes.ADD_CAFE_EVENT_SUCCESS: {
      return {
        ...state,
        addCafeEventLoading: false,
        addCafeEventFailed: false,
        addCafeEventError: false,
        addCafeEventMessage: null
      };
    }
    case actionTypes.ADD_CAFE_EVENT_REJECT: {
      return {
        ...state,
        addCafeEventLoading: false,
        addCafeEventFailed: false,
        addCafeEventError: true,
        addCafeEventMessage: null
      };
    }
    case actionTypes.ADD_CAFE_EVENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        addCafeEventLoading: false,
        addCafeEventFailed: true,
        addCafeEventError: false,
        addCafeEventMessage: message
      };
    }

    case actionTypes.UPDATE_CAFE_EVENT_LOADING: {
      return {
        ...state,
        updateCafeEventLoading: true,
        updateCafeEventFailed: false,
        updateCafeEventError: false,
        updateCafeEventMessage: null
      };
    }
    case actionTypes.UPDATE_CAFE_EVENT_SUCCESS: {
      return {
        ...state,
        updateCafeEventLoading: false,
        updateCafeEventFailed: false,
        updateCafeEventError: false,
        updateCafeEventMessage: null
      };
    }
    case actionTypes.UPDATE_CAFE_EVENT_REJECT: {
      return {
        ...state,
        updateCafeEventLoading: false,
        updateCafeEventFailed: false,
        updateCafeEventError: true,
        updateCafeEventMessage: null
      };
    }
    case actionTypes.UPDATE_CAFE_EVENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateCafeEventLoading: false,
        updateCafeEventFailed: true,
        updateCafeEventError: false,
        updateCafeEventMessage: message
      };
    }

    case actionTypes.REJECT_CAFE_EVENT_LOADING: {
      return {
        ...state,
        rejectEventLoading: true,
        rejectEventFailed: false,
        rejectEventError: false,
        rejectEventMessage: null
      };
    }
    case actionTypes.REJECT_CAFE_EVENT_SUCCESS: {
      return {
        ...state,
        rejectEventLoading: false,
        rejectEventFailed: false,
        rejectEventError: false,
        rejectEventMessage: null
      };
    }
    case actionTypes.REJECT_CAFE_EVENT_REJECT: {
      return {
        ...state,
        rejectEventLoading: false,
        rejectEventFailed: false,
        rejectEventError: true,
        rejectEventMessage: null
      };
    }
    case actionTypes.REJECT_CAFE_EVENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        rejectEventLoading: false,
        rejectEventFailed: true,
        rejectEventError: false,
        rejectEventMessage: message
      };
    }

    case actionTypes.CONFIRM_CAFE_EVENT_LOADING: {
      return {
        ...state,
        confirmEventLoading: true,
        confirmEventFailed: false,
        confirmEventError: false,
        confirmEventMessage: null
      };
    }
    case actionTypes.CONFIRM_CAFE_EVENT_SUCCESS: {
      return {
        ...state,
        confirmEventLoading: false,
        confirmEventFailed: false,
        confirmEventError: false,
        confirmEventMessage: null
      };
    }
    case actionTypes.CONFIRM_CAFE_EVENT_REJECT: {
      return {
        ...state,
        confirmEventLoading: false,
        confirmEventFailed: false,
        confirmEventError: true,
        confirmEventMessage: null
      };
    }
    case actionTypes.CONFIRM_CAFE_EVENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        confirmEventLoading: false,
        confirmEventFailed: true,
        confirmEventError: false,
        confirmEventMessage: message
      };
    }

    case actionTypes.DISABLE_CAFE_EVENT_LOADING: {
      return {
        ...state,
        disableEventLoading: true,
        disableEventFailed: false,
        disableEventError: false,
        disableEventMessage: null
      };
    }
    case actionTypes.DISABLE_CAFE_EVENT_SUCCESS: {
      return {
        ...state,
        disableEventLoading: false,
        disableEventFailed: false,
        disableEventError: false,
        disableEventMessage: null
      };
    }
    case actionTypes.DISABLE_CAFE_EVENT_REJECT: {
      return {
        ...state,
        disableEventLoading: false,
        disableEventFailed: false,
        disableEventError: true,
        disableEventMessage: null
      };
    }
    case actionTypes.DISABLE_CAFE_EVENT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        disableEventLoading: false,
        disableEventFailed: true,
        disableEventError: false,
        disableEventMessage: message
      };
    }
    case actionTypes.CLEAR_ADD_EVENT_FORM: {
      return {
        ...state,
        addCafeEventLoading: false,
        addCafeEventFailed: false,
        addCafeEventError: false,
        addCafeEventMessage: ''
      };
    }

    default: {
      return { ...state };
    }
  }
};
